import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Header = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Title = styled.h2`
    font-weight: 600;
    font-size: 24px;
    font-family: Montserrat, sans-serif;
    color: #000000;
    margin-bottom: 24px;
`;

export const Icon = styled.div`
    margin-bottom: 16px;
`;

export const Text = styled.p`
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-weight: medium;
    color: #707070;
    text-align: center;
    margin-bottom: 28px;
    width: 480px
`;
